import { render, staticRenderFns } from "./AssociatedPeopleV4.vue?vue&type=template&id=3bc38298&scoped=true"
import script from "./AssociatedPeopleV4.vue?vue&type=script&lang=js"
export * from "./AssociatedPeopleV4.vue?vue&type=script&lang=js"
import style0 from "./AssociatedPeopleV4.vue?vue&type=style&index=0&id=3bc38298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc38298",
  null
  
)

export default component.exports